// 開発環境のみconsole.logを実行
export function devLog(){
    if( process.env.REACT_APP_DEVELOPMENT === 'true' ){
        // for (var i = 0; i < arguments.length; i++) {
        //     console.log(arguments[i]);
        // }
        console.log('devLog', ...arguments);
    }
}

/**
 * cancellation token to abort async function
 * @see http://stackoverflow.com/questions/32897385/abort-ecmascript7-async-function
 */
export class CancellationToken {

    isCancellationRequested = false;

    constructor(parentToken = null) {
      this.cancellationPromise = new Promise(resolve => {
        this.cancel = e => {
          this.isCancellationRequested = true;
          if (e) {
            resolve(e);
          } else {
            var err = new Error("cancelled");
            err.cancelled = true;
            resolve(err);
          }
        }
      });
      if (parentToken && parentToken instanceof CancellationToken) {
        parentToken.register(this.cancel);
      }
    }

    register(callback) {
      this.cancellationPromise.then(callback);
    }

    createDependentToken() {
      return new CancellationToken(this);
    }

}



// WEBPACK FOOTER //
// ./src/functions.js